export const formatNumber = (number) => ((number < 10) ? (`0${number}`) : number);
